import http from '@/assets/common/http';

// 获取买卖双方开票单位
export function getSellerBuyerInvoiceInfo(data) {
  const params = {
    SERVICE_ID: '15070',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 名称模糊查询拉取购买方开票单位列表
export function queryBuyerInvoiceInfoListByName(data) {
  const params = {
    SERVICE_ID: '15070',
    OTYPE: 2,
    ...data,
  };
  return http.post(params);
}
// 申请发票
export function submitRequest(data) {
  const params = {
    SERVICE_ID: '15070',
    OTYPE: 3,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 发票申请审核
export function invoiceRequestAudit(data) {
  const params = {
    SERVICE_ID: '15070',
    OTYPE: 4,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取发票列表
export function getInvoiceList(data) {
  const params = {
    SERVICE_ID: '15070',
    OTYPE: 5,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取发票详情
export function getInvoiceDetail(data) {
  const params = {
    SERVICE_ID: '15070',
    OTYPE: 6,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 未开发票转已开
export function turnToInvoiced(data) {
  const params = {
    SERVICE_ID: '15070',
    OTYPE: 7,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 发起退票申请
export function returnInvoice(data) {
  const params = {
    SERVICE_ID: '15070',
    OTYPE: 8,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 审批退票申请
export function invoiceReturnAudit(data) {
  const params = {
    SERVICE_ID: '15070',
    OTYPE: 9,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取发票最大金额
export function getInvoiceMaxFee(data) {
  const params = {
    SERVICE_ID: '15070',
    OTYPE: 10,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取发票关联订单
export function getInvoiceBindOrders(data) {
  const params = {
    SERVICE_ID: '15070',
    OTYPE: 11,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出订单绑定附件
export function exportInvoiceBindOrders(data) {
  const params = {
    SERVICE_ID: '15070',
    OTYPE: 12,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/invoice.js